module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-10.c13e44be.jpg";